import { IxSwitch } from './IxSwitch.js';

window.customElements.define('ix-switch', IxSwitch);
